const clickers = document.querySelectorAll('.js-clicker');

if (clickers) {
    clickers.forEach((clicker) => {
        const links = clicker.querySelectorAll('.clicker-links a');

        if (links) {
            links.forEach((link) => {
                link.addEventListener('mouseenter', handleClickerEnter);
                link.addEventListener('mouseleave', handleClickerLeave);
            });
        }
    });
}

function handleClickerEnter(e) {
    const target = e.target.closest('a');
    if (!target) {
        return;
    }

    const image = getClickerImage(target);

    if (image) {
        const clicker = image.closest('.js-clicker');
        clicker.classList.add('is-showing-image');
        image.style.transition = 'opacity .25s ease-in-out';
        image.classList.add('is-visible');
    }
}

function handleClickerLeave(e) {
    const target = e.target.closest('a');
    if (!target) {
        return;
    }

    const image = getClickerImage(target);

    if (image) {
        const clicker = image.closest('.js-clicker');
        clicker.classList.remove('is-showing-image');
        image.classList.remove('is-visible');
    }
}

function getClickerImage(link) {
    const clicker = link.closest('.js-clicker');
    if (!clicker) {
        return false;
    }

    const imageId = link.dataset.image;
    const image = clicker.querySelector(`picture[data-image="${imageId}"]`);

    return image;
}
